import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./Dimensions.scss";

const Dimensions = ({ list, selectedConfig, handleHotspotClick }) => {
  const hotspotDataInfo = list?.hotspotDataInfo || [];
  const [hoveredHotspot, setHoveredHotspot] = useState(null);
  const [activeHotspots, setActiveHotspots] = useState([]);

  // ---------------------------
  // Update active hotspots when submenu or hotspot data changes
  // ---------------------------
  useEffect(() => {
    if (!hotspotDataInfo.length) {
      setActiveHotspots([]);
      return;
    }
    // All hotspots active by default
    // console.log('hotspotDataInfo changed:', hotspotDataInfo);
    const newActive = hotspotDataInfo.map((h) => h.hsname);
    setActiveHotspots(newActive);
  }, [hotspotDataInfo, selectedConfig?.currentSelectedSubmenu]);

  // ---------------------------
  // Responsive popup style
  // ---------------------------
  const getPopupStyleFromMedia = (hotspot) => {
    if (!hotspot?.media || !Array.isArray(hotspot.media) || hotspot.media.length === 0) return undefined;

    const mediaObj = hotspot.media[0];
    const bpKeys = Object.keys(mediaObj).map((k) => parseInt(k, 10)).filter((n) => !isNaN(n)).sort((a, b) => a - b);

    let chosenBp = bpKeys[0];
    const winW = window.innerWidth || document.documentElement.clientWidth || 0;
    for (let i = 0; i < bpKeys.length; i++) if (bpKeys[i] <= winW) chosenBp = bpKeys[i]; else break;

    const styleObj = mediaObj[String(chosenBp)] || mediaObj[chosenBp];
    if (!styleObj) return undefined;

    return {
      position: "absolute",
      left: styleObj.left,
      top: styleObj.top,
      width: styleObj.width,
      height: styleObj.height,
    };
  };

  // ---------------------------
  // Hotspot click
  // ---------------------------
  const onHotspotClick = (hotspot) => {
    // alert("Dimension Hotspot clicked: " + hotspot.hsname);
    // Remove clicked from active, rest add
    // console.log('hotspotDataInfo:', hotspotDataInfo);
    setActiveHotspots(hotspotDataInfo.filter((h) => h.hsname !== hotspot.hsname).map((h) => h.hsname));
    // console.log("Clicked hotspot:", hotspot.hsname);

    handleHotspotClick(list, hotspotDataInfo, true, hotspot.hsname);
  };
  // console.log("Rendering Dimensions with activeHotspots:", activeHotspots);
  return (
    <>
      {hotspotDataInfo.map((hotspot) => {
        const hotspotId = hotspot.htmlid || hotspot.hsname;
        const imageSrc = window.isMobIsipadIsPotrait ? hotspot?.mobIcon || hotspot?.icon : hotspot?.icon;
        const mountNode = document.getElementById("dimensionsWrapper") || document.body;
        const popupMountNode = document.getElementById("popupContainer") || mountNode;

        const hotspotElement = (
          <div
            id={hotspot.hsname}
            // className={`dimensions popupbox tempHotspot ${window.selectedConfig.hotspotDataInfo && window.selectedConfig.hotspotDataInfo.includes(hotspot.hsname) ? "active" : ""}`}
            className={`dimensions popupbox tempHotspot ${window.selectedConfig.hotspotDataInfo && window.selectedConfig.hotspotDataInfo.includes(hotspot.hsname) ? "" : ""}`}
            data-info={JSON.stringify({ ...hotspot, parentId: list.id })}
            onClick={() => onHotspotClick(hotspot)}             
            onMouseEnter={() => setHoveredHotspot(hotspot.hsname)}
            onMouseLeave={() => setHoveredHotspot(null)}         >
            {!hotspot.icon && !hotspot.icon2 ? (
              <div className="hotspots btn-pulse" id="hotspot_circle">
                <span className="ring">
                  <span className="ring"></span>
                </span>
                <span className="circle collapsible popuptogglebtn"></span>
              </div>
            ) : (
              <div className="dimensionWithIcon">
                <img src={imageSrc} alt={hotspot.popupHeading} />
                <span className="dimensionText">{hotspot.diamension_text}</span>
              </div>
            )}

            {hoveredHotspot === hotspot.hsname && hotspot.hoverText && (
              <div className="hotspotTooltip">{hotspot.hoverText}</div>
            )}
          </div>
        );

        const popupStyle = getPopupStyleFromMedia(hotspot);
        
const hasPopupContent =
  hotspot.popupHeading ||
  hotspot.content?.[0]?.text;
       const popupElement = hasPopupContent ? (
  <div
    id={`hotspot_popup_${hotspotId}`}
    className="popup"
    role="dialog"
    aria-modal="false"
    data-hotspot={hotspotId}
    style={popupStyle}
  >
    {hotspot.popupHeading && <h2>{hotspot.popupHeading}</h2>}

    {Array.isArray(hotspot.content) && hotspot.content.length > 0 && (
  <div className="content">
    <ul>
      {hotspot.content.map((item, index) => {
        if (!item.text) return null;

        return (
          <li key={index}>
            {item.text}
          </li>
        );
      })}
    </ul>
  </div>
)}

  </div>
) : null;

        return (
          <React.Fragment key={hotspot.hsname}>
            {ReactDOM.createPortal(hotspotElement, mountNode)}
            {ReactDOM.createPortal(popupElement, popupMountNode)}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Dimensions;